/**
 *
 * @param {String} pubDate
 * @returns {Boolean}
 */
export const isNotYetPublished = pubDate => {
	return new Date(pubDate) > new Date();
};
